import React from 'react'
import { FaCheckCircle, FaTimesCircle, FaExclamationCircle } from 'react-icons/fa'

const defaultIcons = {
  success: <FaCheckCircle />,
  error: <FaTimesCircle />,
  info: <FaExclamationCircle />
}

export default defaultIcons
